document.addEventListener('DOMContentLoaded', () => {
    const latestWins = {
        interval: 5000,
        minProfit: 5000,
        maxProfit: 15000,
        maxItems: 10,
        wins: [],
        multiSceheme: '',
        profitScheme: '',
        betScheme: '',
        _generateValue(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min
        },
        _sortWins() {
            this.wins = this.wins.slice(0, this.maxItems)
        },
        _configure() {
            if (window.winsConfig) {
                const { interval, minProfit, maxProfit } = window.winsConfig

                this.interval = !isNaN(interval) ? interval * 1000 : this.interval
                this.minProfit = !isNaN(minProfit) ? minProfit : this.minProfit
                this.maxProfit = !isNaN(maxProfit) ? maxProfit : this.maxProfit
            }

            rows.forEach(row => {
                const itemBet = row.querySelector('.bet')?.textContent || ''
                const itemMultiplier = row.querySelector('.multiplier')?.textContent || ''
                const itemPayout = row.querySelector('.payout')?.textContent || ''

                if (!this.multiSceheme && !this.profitScheme && !this.betScheme) {
                    this.multiSceheme = itemMultiplier.replace(/(\d)\s(\d)/gi, '$1$2')
                    this.profitScheme = itemPayout.replace(/(\d)\s(\d)/gi, '$1$2')
                    this.betScheme = itemBet.replace(/(\d)\s(\d)/gi, '$1$2')
                }

                const profit = !isNaN(itemPayout) ? parseFloat(itemPayout) : this._generateValue(this.minProfit, this.maxProfit)
                const multiplier = !isNaN(itemMultiplier) ? parseFloat(itemMultiplier) : this._generateValue(2, 100)
                const bet = !isNaN(itemBet) ? parseFloat(itemBet) : profit / multiplier

                const game = row.querySelector('.game-title')?.innerHTML
                const player = row.querySelector('.player')?.innerHTML

                this.wins.push({ bet, multiplier, profit, game, player })
            })

            this.maxItems = rows.length
        },
        __getGameAndPlayer() {
            const game = this.wins[this._generateValue(0, this.wins.length - 1)].game
            const player = this.wins[this._generateValue(0, this.wins.length - 1)].player

            return { game, player }
        },
        _generateNewRow() {
            const profit = this._generateValue(this.minProfit, this.maxProfit)
            const multiplier = this._generateValue(2, 100)
            const bet = Math.floor(profit / multiplier)

            this.wins.unshift({ bet, multiplier, profit, ...this.__getGameAndPlayer() })
            this._sortWins()
        },
        _renderScheme(scheme, value) {
            return scheme.replace(/\d+/i, value)
        },
        _updateRows() {
            const rows = this.wins.map(win => {
                return `
                    <tr>
                        <td>${win.game}</td>
                        <td>${win.player}</td>
                        <td>${this._renderScheme(this.betScheme, Math.floor(win.bet))}</td>
                        <td>${this._renderScheme(this.multiSceheme, Math.floor(win.multiplier))}</td>
                        <td>${this._renderScheme(this.profitScheme, Math.floor(win.profit))}</td>
                    </tr>
                `
            }).join('')

            const table = document.querySelector('.latestwins-list tbody')

            table.innerHTML = ''
            table.insertAdjacentHTML('beforeend', rows)
        },
        _loop() {
            setTimeout(() => {
                this._generateNewRow()
                this._updateRows()
                this._loop()
            }, this.interval)
        },
        start(rows) {
            if (!rows.length && ! window.winsConfig) {
                return
            }

            this._configure(rows)
            this._loop()
        },
    }

    const rows = document.querySelectorAll('.latestwins-list tbody tr')

    latestWins.start(rows)
})